module.exports = __webpack_public_path__ + "static/media/websocket.3e65df6a.svg";